var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authenticatedUser)?_c('div',[_c('b-container',[_c('RecipesSection',{attrs:{"type":"BOOKMARKED"}}),_vm._v(" "),_c('ResourcesSection',{attrs:{"type":"BOOKMARKED"}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc92f758","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Bookmarks.vue
// module id = null
// module chunks = 